import { DonoTrainGoalsBox } from "@/Components/DonoTrainGoalsBox/DonoTrainGoalsBox";
import { useSocketCallback } from "@/hooks/useSocketCallback";
import { useSocketEvent } from "@/hooks/useSocketEvent";
import { DonoTrainSettings } from "@ailenax-overlay/shared";
import { FC, useState } from "react";

export const DonoTrainGoalsWidget: FC = () => {
    const [settings, setSettings] = useState<DonoTrainSettings | null>(null);
    const [visible, setVisible] = useState<boolean>(false);

    useSocketEvent("dono-train-settings-update", (e) => {
        setSettings(e.settings);
    });

    useSocketEvent("dono-train-goal-box-visibility", (e) => {
        setVisible(e.visible);
    });

    useSocketCallback("get-donotrain-settings", setSettings);
    useSocketCallback("get-donotrain-goal-box-visibility", setVisible);

    return settings && (
        <div className="w-full flex justify-center">
            <DonoTrainGoalsBox settings={settings} visible={visible} />
        </div>
    )
}